import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQuestion = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M4.9502 8.69961C4.9502 9.11382 5.28598 9.44961 5.7002 9.44961C6.11441 9.44961 6.4502 9.11382 6.4502 8.69961H4.9502ZM11.2502 18.2996C11.2502 18.7138 11.586 19.0496 12.0002 19.0496C12.4144 19.0496 12.7502 18.7138 12.7502 18.2996H11.2502ZM12.7502 21.2996C12.7502 20.8854 12.4144 20.5496 12.0002 20.5496C11.586 20.5496 11.2502 20.8854 11.2502 21.2996H12.7502ZM11.2502 21.8996C11.2502 22.3138 11.586 22.6496 12.0002 22.6496C12.4144 22.6496 12.7502 22.3138 12.7502 21.8996H11.2502ZM5.7002 8.69961H6.4502C6.4502 5.19998 8.94872 2.84961 12.0002 2.84961V2.09961V1.34961C8.09288 1.34961 4.9502 4.39923 4.9502 8.69961H5.7002ZM12.0002 2.09961V2.84961C15.0517 2.84961 17.5502 5.19998 17.5502 8.69961H18.3002H19.0502C19.0502 4.39923 15.9075 1.34961 12.0002 1.34961V2.09961ZM18.3002 8.69961H17.5502C17.5502 10.4315 16.2971 12.0336 14.5842 13.1756L15.0002 13.7996L15.4162 14.4236C17.3033 13.1656 19.0502 11.1678 19.0502 8.69961H18.3002ZM15.0002 13.7996L14.5842 13.1756C13.6623 13.7902 12.8249 14.4482 12.2214 15.2672C11.602 16.1078 11.2502 17.0885 11.2502 18.2996H12.0002H12.7502C12.7502 17.4107 12.9984 16.7414 13.429 16.157C13.8755 15.551 14.5381 15.0091 15.4162 14.4236L15.0002 13.7996ZM12.0002 21.2996H11.2502V21.8996H12.0002H12.7502V21.2996H12.0002Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgQuestion);
export { ForwardRef as ReactComponent };
